import styles from './ProductCounter.module.scss';

export const ProductCounter = (props) => {
  return (
    <div className={styles.productCounter}>
        <div style={{ display: "flex", width: "70%" }}>
            <div className={styles.actionsMiddle}>
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/minus_qty.svg"
                    alt="minus"
                    onClick={props.decreaseQty}
                    className={styles.quantityBtn}
                />
                <div className={styles.stock_amount}>{props.quantity}</div>
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/plus_qty.svg"
                    alt="plus"
                    onClick={props.increaseQty}
                    className={styles.quantityBtn}
                />
            </div>
        </div>
    </div>
  )
}